import * as React from "react";
import enLocale from "date-fns/locale/en-US";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import ProgramHttp from "../../../services/api/programaService";
import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/system";
import { dateToDoubletime, stringPrettyToDateTime } from "../../../helpers/timeDateDouble";

export default function Form({ handleAction, handleClose, title, data, ButtonForm }) {
  const getTime = (time) =>
    time !== undefined && time !== null
      ? stringPrettyToDateTime(time)
      : dateToDoubletime(new Date());

  const [programs, setPrograms] = useState([]);
  const [formData, setFormData] = useState({
    ...data,
    time_start: dateToDoubletime(data ? getTime(data && data.time_start) : new Date()),
    time_end: dateToDoubletime(data ? getTime(data && data.time_end) : new Date()),
  });
  const [hours, setHours] = useState({
    time_start: data ? getTime(data && data.time_start) : new Date(),
    time_end: data ? getTime(data && data.time_end) : new Date(),
  });

  const handleChangeFormData = ({ target }) =>
    setFormData({ ...formData, [target.name]: target.value });

  const handleChangeTimeStart = (newTime) => {
    setHours({ ...hours, time_start: newTime });
    setFormData({ ...formData, time_start: dateToDoubletime(newTime) });
  };

  const handleChangeTimeEnd = (newTime) => {
    setHours({ ...hours, time_end: newTime });
    setFormData({ ...formData, time_end: dateToDoubletime(newTime) });
  };

  const action = async () => {
    await handleAction({ formData });
  };

  const ampm = undefined;

  const getData = async () => {
    const {
      data: { data: programs },
    } = await ProgramHttp.getAll();
    setPrograms(programs);
  };

  const days = [
    { name: "Lunes", number: 1 },
    { name: "Martes", number: 2 },
    { name: "Miércoles", number: 3 },
    { name: "Jueves", number: 4 },
    { name: "Viernes", number: 5 },
    { name: "Sábado", number: 6 },
    { name: "Domingo", number: 7 },
  ];

  useEffect(() => {
    async function fetchData() {
      await getData();
    }
    fetchData();
  }, [programs, formData]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enLocale}>
      <Stack spacing={3}>
        <Typography gutterBottom variant="h5" component="div" sx={{ mb: 3 }}>
          {title}{" "}
        </Typography>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label" onChange={() => {}}>
            Programa
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={formData.program_id && programs.length > 0 ? formData.program_id : ""}
            displayEmpty
            label="Programa"
            name={"program_id"}
            onChange={handleChangeFormData}
          >
            {programs.map((program, index) => (
              <MenuItem key={index} value={program._id}>
                {program.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>{" "}
        <FormControl sx={{ mt: 3, mb: 3 }} fullWidth>
          <InputLabel id="demo-simple-select-label">Dia</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={formData.week_day ?? ""}
            label="Dia"
            name={"week_day"}
            onChange={handleChangeFormData}
          >
            {days.map((day, index) => (
              <MenuItem key={index} value={day.number}>
                {day.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TimePicker
          name={"time_start"}
          label={"Hora inicial"}
          value={hours.time_start ?? new Date()}
          onChange={handleChangeTimeStart}
          renderInput={(params) => <TextField {...params} />}
          ampm={ampm}
        />
        <TimePicker
          name={"time_end"}
          label={"Hora final"}
          value={hours.time_end ?? new Date()}
          onChange={handleChangeTimeEnd}
          renderInput={(params) => <TextField {...params} />}
          ampm={ampm}
        />
        <TextField
          name="order"
          fullWidth
          value={formData.order ?? ""}
          required
          label="Numero de orden"
          sx={{ mr: 3, mb: 3 }}
          onChange={handleChangeFormData}
        />
        <Box sx={{ display: "flex" }}>
          <LoadingButton
            size="small"
            color="secondary"
            onClick={() => handleClose()}
            variant="contained"
            sx={{ ml: 27, mt: 1 }}
          >
            {ButtonForm.textCancel}
          </LoadingButton>
          <LoadingButton
            size="small"
            color="secondary"
            onClick={action}
            loadingPosition="start"
            startIcon={ButtonForm.icon}
            variant="contained"
            sx={{ ml: "auto", mt: 1 }}
          >
            {ButtonForm.text}
          </LoadingButton>
        </Box>
      </Stack>
    </LocalizationProvider>
  );
}
